<template>

<div class="main-content main_center" :style="mainContentViewHeight" style="padding-top: 0px">
    <div class="search-content">
        <div class="mainBtn">

        </div>
        <div class="searchBtn">
            <span class="label-form">年份：</span>
            <el-select v-model="dataForm.year" value-key="value" style="width:130px;display: inline-block"  @change="yearsChange">
                <el-option v-for="(item,index) in yearsList"
                           :key="index"
                           :label="item"
                           :value="item"></el-option>
            </el-select>
            <span class="label-form">日志类型：</span>
            <el-select v-model="dataForm.logType" value-key="value" clearable style="width:130px;display: inline-block"  @change="logTypeChange">
                <el-option v-for="(item,index) in logTypeList"
                           :key="index.value"
                           :label="item.label"
                           :value="item.value"></el-option>
            </el-select>
            <span class="label-form">数据状态：</span>
            <el-select v-model="dataForm.status" value-key="value" clearable style="width:130px;display: inline-block"  @change="logTypeChange">
                <el-option v-for="(item,index) in statusList"
                           :key="index.value"
                           :label="item.label"
                           :value="item.value"></el-option>
            </el-select>
            <span class="label-form">业务id：</span>
            <el-input v-model="dataForm.businessId" style="width: 200px" clearable placeholder="请输入内容搜索" @keyup.enter.native="searchBtn"></el-input>
            <span class="label-form">关键字搜索：</span>
            <el-input v-model="dataForm.searchKey" style="width: 200px" placeholder="节点信息" clearable></el-input>
            <el-button size="small" style="margin-left: 12px" type="primary" @click="searchBtn">搜索</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button type="text" icon="el-icon-refresh" @click="refresh"></el-button>
        </div>
    </div>
    <el-table
      :data="dataList"
      border
      :header-cell-style="this.$globalGrayTableHeaderStyle"
      stripe
      ref="dataList"
      :height="tableMaxHeight"
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;">
      <el-table-column
        align="center"
        label="序号"
        show-overflow-tooltip
        width="95"
        >
        <template #default="{ $index }">
            {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        header-align="center"
        align="center"
        :show-overflow-tooltip="true"
        label="键值">
      </el-table-column>
      <el-table-column
        prop="logName"
        header-align="center"
        align="center"
        :show-overflow-tooltip="true"
        label="日志类型">
      </el-table-column>
      <el-table-column
        prop="flowNodeName"
        header-align="center"
        align="center"
        :show-overflow-tooltip="true"
        label="节点名称">
      </el-table-column>
      <el-table-column
        prop="businessId"
        header-align="center"
        align="center"
        :show-overflow-tooltip="true"
        label="业务id">
      </el-table-column>
      <el-table-column  prop="status"
                        header-align="center"
                        align="center"
                        label="入库结果">
        <template slot-scope="scope">
          <el-tooltip effect="light" :content="scope.row.result" placement="top-end">
          <el-tag :type="scope.row.status?'success':'danger'">{{scope.row.status?"入库成功":"入库失败"}}</el-tag>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        width="180"
        label="创建时间">
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="160"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showDetail(scope.row)">详情</el-button>
          <el-button type="text" size="small" @click="pushTo(scope.row)">重推</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <sys-trans-logs-detail ref="showDetail" @repush="pushTo" @refreshDataList="getDataList" />
  </div>
</template>

<script>
    import SysTransLogsDetail from './detail'
    import {nearSixYearsList} from '@/utils/index';

    export default {
    name : "SysTransLogsTable",
    props: ['mainContentViewHeight'],
    data () {
      return {
        dataForm: {
            year:new Date().getFullYear(),
            searchKey: '',
            businessId: '',
            logType: null,
            status:null
        },
        yearsList:[],
        logTypeList:[],
        dataList: [],
        tableMaxHeight: document.documentElement.clientHeight - 238,
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: [],
        addOrUpdateVisible: false,
        statusList:[
          {value:0,label:"入库失败"},
          {value:1,label:"入库成功"}
        ]
      }
    },
    components: {
      SysTransLogsDetail
    },
    created() {
        this.yearsList = nearSixYearsList(this.dataForm.year)
        this.getLogType()
    },
    activated () {
      this.getDataList()
    },
      mounted() {
          const that = this;
          let resizeTag = true
          window.onresize = () => {
              if (resizeTag) { //防抖动
                  that.ifmove();
                  resizeTag = false
                  setTimeout(() => {
                      resizeTag = true
                  }, 1000)
              }
          }
          that.ifmove();
      },
    methods: {
        ifmove() {
            let tableMaxHeight = document.documentElement.clientHeight - 238;
            this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
            this.$nextTick(() => {
                this.tableMaxHeight = tableMaxHeight
            })
            // this.getDataList()
        },
        yearsChange(val){
            this.yearsList = nearSixYearsList(val)
            this.getDataList()
        },
        logTypeChange(){
            this.getDataList();
        },
      // 获取数据列表
      getDataList () {
        this.dataListLoading = true
        this.$httpReq.post('/transLogs/list',{
          'page': this.pageIndex,
          'rows': this.pageSize,
          'searchKey':this.dataForm.searchKey,
          'filter':{
              "year":this.dataForm.year,
              "logType":this.dataForm.logType || null ,
              "businessId":this.dataForm.businessId,
              "status":this.dataForm.status === 0 ? 0 : this.dataForm.status == 1 ? 1 : null,
          }
        }).then(({data}) => {
          if (data ) {
            this.dataList = data.rows;
            this.totalPage = data.totalItemCount;
            this.$refs.dataList.doLayout();
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
      },
      getLogType() {
          this.$httpReq.get('/transLogs/getLogType').then(({data}) => {
              if (data ) {
                  this.logTypeList = data.data;
              }
          })
      },
      getRowsIndex(index) {
        return (this.pageIndex - 1) * this.pageSize + index + 1
      },
        searchBtn() { //搜索按钮
            this.pageIndex = 1;
            this.pageSize = 10;
            this.getDataList()
        },
        refresh() {//刷新按钮
            this.pageIndex = 1;
            this.dataForm.logType = '';
            this.dataForm.businessId = '';
            this.dataForm.searchKey = '';
            this.getDataList()

        },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 多选
      selectionChangeHandle (val) {
        this.dataListSelections = val
      },
      showDetail(row){
        this.$refs['showDetail'].show(row)
      },

      pushTo(mode){
        this.$httpReq.post('/transLogs/pushTo?id='+mode.id).then(({data}) => {
          if (data.code!=1){
            this.$message.error(data.msg);
            return;
          }
          this.$message.success("数据推送成功")
        })
      },
      parseJson(str){
          return JSON.parse(str);
      }
      // 删除
      // deleteHandle (id) {
      //   this.$confirm(`确定要删除该数据?`, '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.$httpReq({
      //       url: this.$httpReq.adornUrl('/systranslogs/delete'),
      //       method: 'post',
      //       data: id
      //     }).then(({data}) => {
      //       if (data && data.code === '1') {
      //         this.$message({
      //           message: '操作成功',
      //           type: 'success',
      //           duration: 1500,
      //           onClose: () => {
      //             this.getDataList()
      //           }
      //         })
      //       } else {
      //         this.$message.error(data.msg)
      //       }
      //     })
      //   }).catch(() => {})
      // }
    }
  }
</script>
